import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=99f623ee&"
import script from "./OverviewCard.vue?vue&type=script&lang=js&"
export * from "./OverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports